import { IconProps } from "./dto";

export function FolderIcon(prop: IconProps) {
    return (
        <svg width={prop.size} height={prop.size} viewBox="0 0 20 18" fill="none">
            <path d="M18.3333 14.8333C18.3333 15.2754 18.1577 15.6993 17.8452 16.0118C17.5326 16.3244 17.1087 16.5 16.6667 16.5H3.33333C2.8913 16.5 2.46738 16.3244 2.15482 16.0118C1.84226 15.6993 1.66666 15.2754 1.66666 14.8333V3.16667C1.66666 2.72464 1.84226 2.30072 2.15482 1.98816C2.46738 1.67559 2.8913 1.5 3.33333 1.5H7.5L9.16666 4H16.6667C17.1087 4 17.5326 4.17559 17.8452 4.48816C18.1577 4.80072 18.3333 5.22464 18.3333 5.66667V14.8333Z" stroke={prop.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}
